const { func } = require("prop-types");

// src/utils/injectStyle.js
const scaleBasedProperties = ["spacing", "sizing", "borderRadius", "borderThickness", "fontSize", "fontWeight", "lineHeight"];
module.exports =  function injectCSSVariables(colorMappings, category) {
    console.log("INSIDE injectCSSVariables for", category, colorMappings);
    if(category && scaleBasedProperties.includes(category)) {
      colorMappings = computeScaleBasedMappings(colorMappings, category);
    }
    const styleTag = window.document.getElementById('theme-style') || window.document.createElement('style');
    if (!styleTag.id) {
      let cssContent;
      styleTag.id = 'theme-style';
      cssContent = `
            :where(html:not(.slds-non-theming-scope)){`;
      colorMappings.forEach(obj => {
        cssContent += `${obj.name}: ${obj.value};`;
      });
      cssContent += '}';
      styleTag.innerHTML = cssContent;
      document.head.appendChild(styleTag);
    }
    else {
      let newCssContent="";
      let cssContent = document.getElementById("theme-style").innerHTML;
      let pos = cssContent.indexOf("}");
      colorMappings.forEach(obj => {
        if (cssContent.includes(obj.name)) {
          const regex = new RegExp(`${obj.name}\\s*:\\s*[^;]+`);
          cssContent = cssContent.replace(regex, `${obj.name}: ${obj.value}`);
        }
        else {
          newCssContent += `${obj.name}: ${obj.value};`;
        }
      });
      let updatedCss = cssContent.slice(0,pos).concat(newCssContent, cssContent.slice(pos));
      styleTag.innerHTML = updatedCss;
    }
  }

function computeScaleBasedMappings(relativity, category) {
  // relativity.includes("%") && (relativity = relativity.replace("%","")/100);
  var style = window.getComputedStyle(document.body);
  if(category === "spacing1") {
    // let baseSpacingRatio = style.getPropertyValue('--slds-g-spacing-ratio');
    let baseSpacingRatio = 1;
    let newBaseSpacingRatio = baseSpacingRatio * relativity;
    return [{
      name: "--slds-g-spacing-ratio",
      value: newBaseSpacingRatio
    }];
  }
  else if(category === "sizing") {
    // let baseFontScaleRatio = style.getPropertyValue('--slds-g-font-scale-ratio');
    let baseFontScaleRatio = 1;
    let newBaseFontScaleRatio = baseFontScaleRatio * relativity;
    return [{
      name: "--slds-g-font-scale-ratio",
      value: newBaseFontScaleRatio
    }];
  }
  else if(category === "borderRadius" || "borderThickness" || "fontSize" || "fontWeight" || "lineHeight" || "spacing") {
    // let baseFontScaleRatio = style.getPropertyValue('--slds-g-font-scale-ratio');
    let baseRatio = 1;
    var scaleFactor = 0.5 + (relativity/100);
    let newBaseRatio = baseRatio * scaleFactor;
    let relatedStylingHook;
    switch(category) {
      case "borderRadius":
        relatedStylingHook =  "--slds-g-radius-border-ratio";
        break;
      case "borderThickness":
        relatedStylingHook =  "--slds-g-sizing-border-ratio";
        break;
      case "fontSize":
        relatedStylingHook =  "--slds-g-font-scale-ratio"
        break;
      case "fontWeight":
        relatedStylingHook =  "--slds-g-font-weight-ratio"
        break;
      case "lineHeight":
        relatedStylingHook =  "--slds-g-font-lineheight-ratio"
        break;
      case "spacing":
        relatedStylingHook =  "--slds-g-spacing-ratio"
        break;
    
      default:
        break;
    }
    return [{
      name: relatedStylingHook,
      value: newBaseRatio
    }];
  }
  else if(category === "borderRadius") {
    // let baseFontScaleRatio = style.getPropertyValue('--slds-g-font-scale-ratio');
    let baseRadiusBorderRatio = 1;
    var scaleFactor = 0.5 + (relativity/100);
    let newBaseRadiusBorderRatio = baseRadiusBorderRatio * scaleFactor;
    return [{
      name: "--slds-g-radius-border-ratio",
      value: newBaseRadiusBorderRatio
    }];
  }
  else if(category === "borderThickness") {
    // let baseFontScaleRatio = style.getPropertyValue('--slds-g-font-scale-ratio');
    let baseSizingBorderRatio = 1;
    let newBaseSizingBorderRatio = baseSizingBorderRatio * relativity;
    return [{
      name: "--slds-g-sizing-border-ratio",
      value: newBaseSizingBorderRatio
    }];
  }
}
  
// function formatColorMappings(arr1) {
//     const colorToneMappings = {
//         '100': ["--slds-g-color-on-accent-1"],
//          '95': ["--slds-g-color-accent-light-1"],
//          '90': ["--slds-g-color-accent-light-2"],
//          '50': ["--slds-g-color-accent-1", "--slds-g-color-accent-container-1", "--slds-g-color-border-accent-1"],
//          '40': ["--slds-g-color-accent-2", "--slds-g-color-accent-container-2", "--slds-g-color-border-accent-2", "--slds-s-link-color"],
//          '30': ["--slds-g-color-accent-3", "--slds-g-color-accent-container-3", "--slds-g-color-border-accent-3", "--slds-s-link-color-hover", "--slds-s-link-color-focus", "--slds-s-link-color-active"],
//          '20': ["--slds-g-color-accent-light-1"],
//          '10': ["--slds-g-color-accent-light-2"],
//        }
       
//        let finalMappedArray = [];
//        arr1.forEach(colorObj => {
//            let hooksList = colorToneMappings[colorObj.label];
//          if(hooksList && hooksList.length > 1) {
//              hooksList.forEach(hook => {
//                    finalMappedArray.push({
//                         name: hook,
//                         value: colorObj.hex
//                });
//            })
//          }
//          else{
//            hooksList && finalMappedArray.push({
//             name: hooksList[0],
//             value: colorObj.hex
//         }); 
//          }
//        });
//        console.log("finalMappedArray: ", finalMappedArray);
//        return finalMappedArray;
// }